<template>

    <div class="ai-chat-page">
        <div class="chat-container">
            <!-- <div class="pl-1 font-18">{{ pageTitle }}</div> -->
            <div class="messages">
                <div v-for="(mesg, index) in messages" :key="index"
                    :class="[mesg.sender == 'AI' ? 'message-left my-1' : 'message-right message']">
                    <!-- 用户消息 and AI消息-->
                    <div class="typewriter" v-if="mesg.message !== 'thinking'" v-html="mesg.message"></div>

                    <!-- 思考中... -->
                    <div v-if="mesg.message === 'thinking'" class="thinking">
                        <i class="el-icon-loading mr-1"></i>
                        <span>Deepseek正在思考中，请您稍等……</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>

import aiNav from '../inc/aiNav.vue';
// 方式2：尝试其他可能路径
import mermaid from 'mermaid/dist/mermaid';
export default {
    components: { aiNav },
    data() {
        return {
            userdata: {},
            messages: [
                // {sender: "AI", message: "Hi，我是 中投产业专家～很高兴遇见你！"}

            ],
            userInput: { sender: "user", message: "" },
            historyList: [
                { sender: "user", message: "比亚迪股份有限公司拿地数据和投资趋势分析" },
                { sender: "user", message: "宁德时代股份有限公司拿地数据和投资趋势分析" },
            ],
            type: 1, //1土地，2专利，3研发
            model: 1, //1: v3 2: R1
            id: 1,
            isUserScrolling: false, // 标志用户是否正在手动滚动
            pageTitle: '',
            isCumtrade: '',
            svgElDom: null, // 用于存储 Mermaid 图表的 SVG 元素
        };
    },

    created() {
        this.userdata = this.getuseriformation();
        console.log(this.userdata);
        this.type = this.$route.query.type;
        this.model = this.$route.query.model;
        this.id = this.$route.query.id;
        this.isCumtrade = this.$route.query.isCumtrade; //用来判断行业分析，有些是没有单独接口要调详情
    },
    mounted() {
        this.getIndutryChat();
        // 移除所有带有 hyc-common-markdown__ref-list 类名的元素
        const elements = document.querySelectorAll('.hyc-common-markdown__ref-list');
        elements.forEach((element) => {
            element.remove();
        });

    },
    methods: {
        getIndutryChat() {
            let aiChatData = JSON.parse(localStorage.getItem('aiChatData')) || {};
            let that = this;
            let type = this.type;
            let id = this.splicing('id', this.$route.query.id); //市场规模和竞争格局id
            let ajaxUrl = '';
            if (!this.isCumtrade) {
                ajaxUrl = this.$api.common.analyse.chatDetail() + "?type=" + type + id;
            } else {
                ajaxUrl = this.$api.common.customized.chatDetail() + "?id=" + type;

            }
            console.log(ajaxUrl);
            // return;
            // 模拟用户输入
            this.userInput = { sender: "user", message: aiChatData.title };
            // if (!this.userInput.message.trim()) return;
            // 添加用户消息
            this.messages.push(this.userInput);
            // 添加思考动画
            this.messages.push({ sender: "AI", message: "thinking" });
            const userInput = this.userInput; // 保存用户输入
            this.userInput = "";
            this.pageTitle = aiChatData.title;
            document.title = aiChatData.title;
            // 发送请求
            this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
                if (res.data.success) {
                    console.log(res);
                    let thinkingProcess = '', result = '';
                    result = res.data.data.content;
                    thinkingProcess = res.data.data.reason; // 假设后端返回的思考过程字段为 reason
                    let fullMessage = result;
                    // console.log(result,"",thinkingProcess);
                    if (thinkingProcess && thinkingProcess) {
                        fullMessage = `<div class="thinking-process">\n${thinkingProcess}</div><div class="result">${result}</div>`;

                    }

                    that.messages.pop();
                    that.messages.push({ sender: "AI", message: fullMessage });
                    that.$nextTick(() => {
                        that.renderMermaid();
                    });

                } else {
                    that.messages.push({ sender: "AI", message: '系统出错' });
                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },

        // 提取 Mermaid 图表代码并渲染
        async renderMermaid() {
            let containers;
            containers = document.querySelectorAll('.hyc-common-markdown__code-mermaid-show-svg');
            if (!containers || containers.length === 0) { console.warn('未找到任何 Mermaid 图表容器'); return };
            // 遍历每个容器并渲染图表
            for (const container of containers) {
                try {
                    // 初始化配置
                    mermaid.initialize({
                        startOnLoad: false,
                        theme: 'default',
                        suppressErrorRendering: true, // 完全禁止错误提示渲染
                        securityLevel: 'loose',      // 避免严格模式拦截
                        logLevel: 'fatal', // 仅显示致命错误，避免显示版本信息
                        flowchart: {
                            useMaxWidth: false,
                            htmlLabels: true,
                            diagramPadding: 15
                        }
                    });


                    var graphDefinition = container.textContent.trim();
                    // 预处理图表代码
                    graphDefinition = this.preprocessCode(graphDefinition);
                    // 判断是否是雷达图
                    if (graphDefinition.startsWith('radar')) {
                        // 使用 ECharts 渲染雷达图
                        this.renderRadarChart(container, graphDefinition);
                    } else {
                        // 将 graphDefinition 存储在容器的自定义属性中
                        container.setAttribute('data-graph-definition', graphDefinition);
                        console.log('替换特殊字符', graphDefinition);
                        // return;
                        if (!graphDefinition) return;
                        const id = 'mermaid-chart-' + Math.random().toString(36).slice(2, 11);
                        const svg = await mermaid.render(id, graphDefinition);

                        // 创建主容器
                        const wrapper = document.createElement('div');
                        wrapper.className = 'mermaid-wrapper';
                        wrapper.style.position = 'relative';
                        wrapper.style.backgroundColor = 'white'; // 白色背景

                        // 还原图片中的控件栏
                        const controlBarDom =
                            `<div class="hyc-common-markdown__code__hd"><div class="hyc-common-markdown__code__hd__inner"><div class="hyc-common-markdown__code__hd__l"><div class="code-btn-switch"><div class="code-btn active" dt-ext1="9" dt-click="OnPageClick" dt-page-id="AllAgentPage" dt-mod-id="answer_panel" dt-button-id="coding_image_click" dt-agent-id="naQivTmsDa" dt-cid="081414a5-3151-4823-a0df-4a2dd49d78b8" dt-traceid="294436d3300bd5936ced557024a61c3f" dt-model-id="deep_seek_v3" dt-ext2="1">图片</div><div class="code-btn" dt-ext1="8" dt-click="OnPageClick" dt-page-id="AllAgentPage" dt-mod-id="answer_panel" dt-button-id="coding_image_click" dt-agent-id="naQivTmsDa" dt-cid="081414a5-3151-4823-a0df-4a2dd49d78b8" dt-traceid="294436d3300bd5936ced557024a61c3f" dt-model-id="deep_seek_v3" dt-ext2="1">代码</div></div></div><div class="mermaid-expose-placeholder" dt-exposure="OnPageMod" dt-page-id="AllAgentPage" dt-mod-id="answer_panel" dt-button-id="coding_image" dt-agent-id="naQivTmsDa" dt-cid="081414a5-3151-4823-a0df-4a2dd49d78b8" dt-traceid="294436d3300bd5936ced557024a61c3f" dt-model-id="deep_seek_v3" dt-ext2="1"></div><div class="hyc-common-markdown__code__hd__r"><div dt-ext1="1" class="hyc-common-markdown__code__option" dt-click="OnPageClick" dt-page-id="AllAgentPage" dt-mod-id="answer_panel" dt-button-id="coding_image_click" dt-agent-id="naQivTmsDa" dt-cid="081414a5-3151-4823-a0df-4a2dd49d78b8" dt-traceid="294436d3300bd5936ced557024a61c3f" dt-model-id="deep_seek_v3" dt-ext2="1"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0.900391C8.33137 0.900391 8.6 1.16902 8.6 1.50039V10.0519L11.5757 7.07613C11.8101 6.84181 12.1899 6.84181 12.4243 7.07613C12.6586 7.31044 12.6586 7.69034 12.4243 7.92465L9.13137 11.2175C8.50653 11.8424 7.49347 11.8424 6.86863 11.2175L3.57574 7.92465C3.34142 7.69034 3.34142 7.31044 3.57574 7.07613C3.81005 6.84181 4.18995 6.84181 4.42426 7.07613L7.4 10.0519V1.50039C7.4 1.16902 7.66863 0.900391 8 0.900391Z" fill="currentColor"></path><path d="M2.20312 11.602C2.20312 11.2697 1.9338 11.0004 1.60156 11.0004C1.26933 11.0004 1 11.2697 1 11.602V12.5004C1 13.8811 2.11929 15.0004 3.5 15.0004H12.5C13.8807 15.0004 15 13.8811 15 12.5004V11.6004C15 11.269 14.7314 11.0004 14.4 11.0004C14.0686 11.0004 13.8 11.269 13.8 11.6004V12.5004C13.8 13.2184 13.218 13.8004 12.5 13.8004H3.5C2.78203 13.8004 2.2 13.2184 2.2 12.5004V12.2004H2.20312V11.602Z" fill="currentColor"></path></svg></div> <div dt-ext1="3" class="hyc-common-markdown__code__option" dt-click="OnPageClick" dt-page-id="AllAgentPage" dt-mod-id="answer_panel" dt-button-id="coding_image_click" dt-agent-id="naQivTmsDa" dt-cid="081414a5-3151-4823-a0df-4a2dd49d78b8" dt-traceid="294436d3300bd5936ced557024a61c3f" dt-model-id="deep_seek_v3" dt-ext2="1"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.2002 8C13.2002 5.12812 10.8719 2.7998 8 2.7998C5.12812 2.7998 2.7998 5.12812 2.7998 8C2.7998 10.8719 5.12812 13.2002 8 13.2002C10.8719 13.2002 13.2002 10.8719 13.2002 8ZM8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 9.5791 13.9369 11.0267 13.0006 12.1529L14.9238 14.0762L15.001 14.1699C15.1548 14.4028 15.1289 14.7188 14.9238 14.9238C14.7188 15.1289 14.4028 15.1548 14.1699 15.001L14.0762 14.9238L12.1529 13.0006C11.0267 13.9369 9.5791 14.5 8 14.5ZM7.40039 10V8.59961H6C5.66863 8.59961 5.40039 8.33137 5.40039 8C5.40039 7.66863 5.66863 7.40039 6 7.40039H7.40039V6C7.40039 5.66863 7.66863 5.40039 8 5.40039C8.33137 5.40039 8.59961 5.66863 8.59961 6V7.40039H10L10.1211 7.41211C10.3944 7.46811 10.5996 7.7101 10.5996 8C10.5996 8.2899 10.3944 8.53189 10.1211 8.58789L10 8.59961H8.59961V10C8.59961 10.3314 8.33137 10.5996 8 10.5996C7.66863 10.5996 7.40039 10.3314 7.40039 10Z" fill="currentColor"></path></svg></div><div dt-ext1="4" class="hyc-common-markdown__code__option" dt-click="OnPageClick" dt-page-id="AllAgentPage" dt-mod-id="answer_panel" dt-button-id="coding_image_click" dt-agent-id="naQivTmsDa" dt-cid="081414a5-3151-4823-a0df-4a2dd49d78b8" dt-traceid="294436d3300bd5936ced557024a61c3f" dt-model-id="deep_seek_v3" dt-ext2="1"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.2002 8C13.2002 5.12812 10.8719 2.7998 8 2.7998C5.12812 2.7998 2.7998 5.12812 2.7998 8C2.7998 10.8719 5.12812 13.2002 8 13.2002C10.8719 13.2002 13.2002 10.8719 13.2002 8ZM8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 9.5791 13.9369 11.0267 13.0006 12.1529L14.9238 14.0762L15.001 14.1699C15.1548 14.4028 15.1289 14.7188 14.9238 14.9238C14.7188 15.1289 14.4028 15.1548 14.1699 15.001L14.0762 14.9238L12.1529 13.0006C11.0267 13.9369 9.5791 14.5 8 14.5ZM10 7.40039L10.1211 7.41211C10.3944 7.46811 10.5996 7.7101 10.5996 8C10.5996 8.2899 10.3944 8.53189 10.1211 8.58789L10 8.59961H6C5.66863 8.59961 5.40039 8.33137 5.40039 8C5.40039 7.66863 5.66863 7.40039 6 7.40039H10Z" fill="currentColor"></path></svg></div><div dt-ext1="6" class="hyc-common-markdown__code__option" dt-click="OnPageClick" dt-page-id="AllAgentPage" dt-mod-id="answer_panel" dt-button-id="coding_image_click" dt-agent-id="naQivTmsDa" dt-cid="081414a5-3151-4823-a0df-4a2dd49d78b8" dt-traceid="294436d3300bd5936ced557024a61c3f" dt-model-id="deep_seek_v3" dt-ext2="1"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><g id="Outlined"><path d="M2.3998 8.00098C2.06843 8.00098 1.7998 8.2696 1.7998 8.60098V12.2008C1.7998 13.3054 2.69524 14.2008 3.79981 14.2008H7.4C7.73137 14.2008 8 13.9322 8 13.6008C8 13.2694 7.73137 13.0008 7.4 13.0008H3.79981C3.35798 13.0008 2.9998 12.6426 2.9998 12.2008V8.60098C2.9998 8.2696 2.73118 8.00098 2.3998 8.00098Z" fill="currentColor"></path><path d="M8.6 3.00078C8.26863 3.00078 8 2.73215 8 2.40078C8 2.06941 8.26863 1.80078 8.6 1.80078H12.1998C13.3044 1.80078 14.1998 2.69621 14.1998 3.80078V7.40098C14.1998 7.73235 13.9312 8.00098 13.5998 8.00098C13.2684 8.00098 12.9998 7.73235 12.9998 7.40098V3.80078C12.9998 3.35895 12.6416 3.00078 12.1998 3.00078H8.6Z" fill="currentColor"></path></g></g></svg></div></div></div></div>`;

                        // 组合控件栏和图表
                        wrapper.innerHTML = controlBarDom + svg;
                        container.innerHTML = '';
                        container.appendChild(wrapper);

                        const controlBar = wrapper.querySelector('.hyc-common-markdown__code__hd__inner');
                        if (controlBar) {
                            // 1. 图片/代码切换按钮 
                            const tabButtons = controlBar.querySelectorAll('.code-btn');

                            // 图片按钮点击
                            tabButtons[0].addEventListener('click', () => {
                                console.log('图片按钮被点击', container);

                                // 显示图片（SVG 图表）
                                const svgEl = document.getElementById(id);
                                if (svgEl) {
                                    svgEl.style.display = 'block';
                                }

                                // 隐藏代码容器
                                const codeContainer = wrapper.querySelector('.code-container');
                                if (codeContainer) {
                                    codeContainer.style.display = 'none';
                                }

                                // 更新按钮状态
                                tabButtons[0].classList.add('active');
                                tabButtons[1].classList.remove('active');
                            });

                            // 代码按钮点击
                            tabButtons[1].addEventListener('click', (event) => {

                                // 隐藏图片（SVG 图表）获取前面设置的id
                                const svgEl = document.getElementById(id);
                                console.log(svgEl);
                                if (svgEl) {
                                    svgEl.style.display = 'none';
                                }

                                // 显示代码容器
                                let codeContainer = wrapper.querySelector('.code-container');
                                if (!codeContainer) {
                                    // 如果代码容器不存在，则创建一个
                                    codeContainer = document.createElement('div');
                                    codeContainer.className = 'code-container';
                                    codeContainer.style.padding = '10px';
                                    // codeContainer.style.border = '1px solid #ddd';
                                    // codeContainer.style.backgroundColor = '#f9f9f9';
                                    codeContainer.style.whiteSpace = 'pre-wrap'; // 保留换行
                                    codeContainer.style.fontFamily = 'monospace';
                                    wrapper.appendChild(codeContainer);
                                }

                                // 设置代码内容
                                //获取container的data-graph-definition属性
                                codeContainer.textContent = container.getAttribute('data-graph-definition');;
                                codeContainer.style.display = 'block';

                                // 更新按钮状态
                                tabButtons[1].classList.add('active');
                                tabButtons[0].classList.remove('active');
                            });



                            controlBar.addEventListener('click', (event) => {
                                const target = event.target;
                                // 获取 SVG 元素
                                this.svgElDom = document.getElementById(id);
                                // 检查是否点击了具有 dt-ext1 属性的按钮
                                if (target && target.hasAttribute('dt-ext1')) {
                                    const extValue = target.getAttribute('dt-ext1');
                                    switch (extValue) {
                                        case '1':
                                            if (!this.svgElDom) return;
                                            try {
                                                // 优先尝试方案2
                                                const svgStr = new XMLSerializer().serializeToString(this.svgElDom);
                                                const canvas = document.createElement('canvas');
                                                const img = new Image();

                                                img.onload = () => {
                                                    canvas.width = img.width;
                                                    canvas.height = img.height;
                                                    canvas.getContext('2d').drawImage(img, 0, 0);

                                                    canvas.toBlob(blob => {
                                                        const a = document.createElement('a');
                                                        a.href = URL.createObjectURL(blob);
                                                        a.download = 'diagram.png';
                                                        a.click();
                                                        setTimeout(() => URL.revokeObjectURL(a.href), 100);
                                                    }, 'image/png');
                                                };

                                                img.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgStr)}`;
                                            } catch (err) {
                                                console.error('转换失败:', err);
                                                alert('PNG生成失败，请尝试SVG下载');
                                            }
                                            break;
                                            break;
                                        case '3': //放大
                                            if (!this.svgElDom) return;

                                            // 获取当前缩放比例
                                            const currentScale = parseFloat(this.svgElDom.getAttribute('data-scale')) || 1;

                                            // 设置新的缩放比例（逐步放大 1.2 倍，最大放大到 3 倍）
                                            const newScale = Math.min(currentScale * 1.2, 3);

                                            // 应用缩放
                                            this.svgElDom.style.transform = `scale(${newScale})`;
                                            this.svgElDom.style.transformOrigin = 'center'; // 设置缩放中心为图表中心

                                            // 保存新的缩放比例
                                            this.svgElDom.setAttribute('data-scale', newScale);
                                            // 启用拖拽功能（当缩放比例大于 1 时）
                                            // if (newScale > 1) {
                                            //     enableDrag(this.svgElDom);
                                            // }
                                            break;
                                        case '4': //缩小
                                            if (!this.svgElDom) return;

                                            // 获取当前缩放比例
                                            const currentScale1 = parseFloat(this.svgElDom.getAttribute('data-scale')) || 1;

                                            // 设置新的缩放比例（逐步缩小到最小 0.1 倍）
                                            const newScale1 = Math.max(currentScale1 / 1.2, 0.1);

                                            // 应用缩放
                                            this.svgElDom.style.transform = `scale(${newScale1})`;
                                            this.svgElDom.style.transformOrigin = 'center'; // 设置缩放中心为图表中心

                                            // 保存新的缩放比例
                                            this.svgElDom.setAttribute('data-scale', newScale1);
                                            break;
                                        case '6':
                                            if (this.svgElDom) {
                                                this.svgElDom.requestFullscreen()
                                                    .catch(err => {
                                                        console.error('全屏错误:', err);
                                                    });
                                            } else {
                                                document.exitFullscreen();
                                            }
                                            break;
                                    }
                                }

                            });
                        }

                        // 确保SVG样式正确
                        const svgEl = wrapper.querySelector('svg');
                        if (svgEl) {
                            svgEl.style.maxWidth = '100%';
                            // svgEl.style.height = 'auto';
                            svgEl.style.display = 'block';
                        }

                        // 绑定Mermaid交互
                        if (typeof mermaid.bindFunctions === 'function') {
                            mermaid.bindFunctions(wrapper);
                        }


                    }

                } catch (err) {
                    console.error('Mermaid渲染错误:', err);
                    if (container) {
                        container.innerHTML = `<div style="
        display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: #ffffff; /* 白色背景 */
    border-radius: 8px;
    color: #6c757d; /* 灰色文字 */
    font-family: Arial, sans-serif;
    text-align: center;
    height: 280px;
"><svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.89941 10.8016C2.89941 6.8251 6.12296 3.60156 10.0994 3.60156H38.8994C42.8759 3.60156 46.0994 6.82511 46.0994 10.8016V37.2016C46.0994 41.178 42.8759 44.4016 38.8994 44.4016H10.0994C6.12297 44.4016 2.89941 41.178 2.89941 37.2016V10.8016ZM5.29941 12.6016C5.29941 11.6074 6.1053 10.8016 7.09941 10.8016H41.8994C42.8935 10.8016 43.6994 11.6075 43.6994 12.6016V37.2016C43.6994 39.8525 41.5504 42.0016 38.8994 42.0016H10.0994C7.44844 42.0016 5.29941 39.8525 5.29941 37.2016V12.6016ZM25.9998 16.8012C24.5086 16.8012 23.2998 18.01 23.2998 19.5012V20.7012C23.2998 22.1923 24.5086 23.4012 25.9998 23.4012H32.5998C34.091 23.4012 35.2998 22.1923 35.2998 20.7012V19.5012C35.2998 18.01 34.091 16.8012 32.5998 16.8012H25.9998ZM25.6998 19.5012C25.6998 19.3355 25.8341 19.2012 25.9998 19.2012H32.5998C32.7655 19.2012 32.8998 19.3355 32.8998 19.5012V20.7012C32.8998 20.8669 32.7655 21.0012 32.5998 21.0012H25.9998C25.8341 21.0012 25.6998 20.8669 25.6998 20.7012V19.5012ZM23.2998 32.1012C23.2998 30.61 24.5086 29.4012 25.9998 29.4012H32.5998C34.091 29.4012 35.2998 30.61 35.2998 32.1012V33.3012C35.2998 34.7923 34.091 36.0012 32.5998 36.0012H25.9998C24.5086 36.0012 23.2998 34.7923 23.2998 33.3012V32.1012ZM25.9998 31.8012C25.8341 31.8012 25.6998 31.9355 25.6998 32.1012V33.3012C25.6998 33.4669 25.8341 33.6012 25.9998 33.6012H32.5998C32.7655 33.6012 32.8998 33.4669 32.8998 33.3012V32.1012C32.8998 31.9355 32.7655 31.8012 32.5998 31.8012H25.9998ZM17.8998 18.9012C15.9116 18.9012 14.2998 20.5129 14.2998 22.5012V25.2012H12.4998C11.8371 25.2012 11.2998 25.7384 11.2998 26.4012C11.2998 27.0639 11.8371 27.6012 12.4998 27.6012H14.2998V30.3012C14.2998 32.2894 15.9116 33.9012 17.8998 33.9012H20.2998C20.9625 33.9012 21.4998 33.3639 21.4998 32.7012C21.4998 32.0384 20.9625 31.5012 20.2998 31.5012H17.8998C17.2371 31.5012 16.6998 30.9639 16.6998 30.3012V26.4012V22.5012C16.6998 21.8384 17.2371 21.3012 17.8998 21.3012H20.2998C20.9625 21.3012 21.4998 20.7639 21.4998 20.1012C21.4998 19.4384 20.9625 18.9012 20.2998 18.9012H17.8998Z" fill="currentColor"></path></svg>
<p style="margin: 0; font-size: 16px;">渲染失败</p></div>`;
                    }
                    this.removeALLErroDom();
                }
            }

        },
        removeALLErroDom() {
            const elements = document.querySelectorAll('[id^="mermaid-chart-"]');
            console.log(elements);
            for (const element of elements) {
                element.remove();//移除所有带有 id^="mermaid-chart-" 的元素，报错会展示页页面影响体验
            }

        },
        // 渲染雷达图的方法
        renderRadarChart(container, graphDefinition) {
            //手动设置一下容器宽高
            container.style.width = '100%';
            container.style.height = '400px';
            // 解析雷达图的配置
            const radarConfig = this.parseRadarChartConfig(graphDefinition);

            // 创建一个 ECharts 实例
            const chart = echarts.init(container);

            console.log('renderRadarChart', radarConfig);
            // 配置雷达图的选项
            const option = {
                title: {
                    // text: radarConfig.title || '雷达图',
                },
                tooltip: {},
                radar: {
                    indicator: radarConfig.axis.map((name) => ({ name, max: 5 })), // 假设最大值为 5
                },
                series: [
                    {
                        name: radarConfig.seriesName || '重要性',
                        type: 'radar',
                        data: [
                            {
                                value: radarConfig.values,
                                name: radarConfig.seriesName || '重要性',
                            },
                        ],
                    },
                ],
            };

            // 使用 ECharts 渲染图表
            chart.setOption(option);
        },
        // 解析雷达图配置的方法
        parseRadarChartConfig(graphDefinition) {
            // 示例解析逻辑
            // 假设 graphDefinition 格式如下：
            // radarChart
            // title 成功要素重要性雷达图(5星最高)
            // axis 技术,供应链,政策合规,资金实力,人力资源
            // "重要性" [5,4.3,4.2,3.8,3.5]

            const lines = graphDefinition.split('\n').slice(1); // 去掉第一行 "radarChart"
            console.log('解析雷达图配置的方法', graphDefinition, lines);

            const config = {
                axis: [],
                values: [],
            };

            lines.forEach((line) => {
                // 去除每行的多余空格
                line = line.trim();

                // 分割 key 和 value
                const [key, value] = line.split(/\s+/, 2); // 使用正则表达式按空白字符分割，并限制为两部分
                console.log('解析雷达图配置的方法', key, value);

                if (key === 'title') {
                    config.title = value;
                } else if (key === 'axis') {
                    config.axis = value.split(',').map((item) => item.trim());
                } else if (key.startsWith('"') && key.endsWith('"')) {
                    config.seriesName = key.replace(/"/g, '');
                    config.values = JSON.parse(value);
                }
            });

            return config;
        },
        // 预处理Mermaid代码
        preprocessCode(text) {
            const symbolMap = {
                '＜': '<',
                '＞': '>',
                '￥': 'CNY',
                '【': '[',
                '】': ']',
                '‘': "'",
                '’': "'",
                '“': '"',
                '”': '"',
                '——': '--',
                '→': '->',
                '｛': '{',
                '｝': '}',
                '<': '<=',
                '≥': '>=',
                '≤': '<=',
                '（': '(',
                '）': ')',
                '：': ':',
                '，': ',',
                '％': '%',
                '⭐': ' &#9733',
                'vs': '<sub>vs</sub>',
            };

            let resText = text
                .replace(/[＜＞￥【】‘’“”→｛｝<≥≤（）：，％⭐vs]/g, char => symbolMap[char] || char);

            // Standardize pie chart formatting
            resText = resText.replace(/^\s*pie\s+/gm, 'pie\n')  // Ensure pie starts on new line
                .replace(/^\s*title\s+/gm, '    title ')       // Indent title
                .replace(/(\d+)%/g, '$1'); // Ensure percentages for pie data
            // 标准化 pie 图表格式
            if (resText.trim().startsWith('pie')) {
                const lines = resText.split('\n').map(line => line.trim()).filter(line => line);
                const result = ['pie'];

                // 检查并处理标题
                let hasTitle = false;
                lines.forEach(line => {
                    if (line.startsWith('title')) {
                        hasTitle = true;
                        result.push(line); // 保留标题
                    }
                });
                if (!hasTitle) {
                    result.push('    title 默认标题'); // 如果没有标题，添加默认标题
                }

                // 处理数据项
                lines.forEach(line => {
                    if (line.startsWith('"') && line.includes(':')) {
                        result.push(line); // 保留有效数据项
                    }
                });

                // 如果没有数据项，添加默认数据
                if (result.length === 2) {
                    result.push('    "默认数据1" : 50');
                    result.push('    "默认数据2" : 50');
                }

                resText = result.join('\n');
            }
            return resText;
        },
        typeText(message, index) {
            if (index < message.message.length) {
                message.displayMessage += message.message.charAt(index);
                requestAnimationFrame(() => {
                    this.typeText(message, index + 1);
                });
            }
        },
        typeAnswer(answer, callback, isResult = false) {
            let i = 0;
            const timer = setInterval(() => {
                if (i < answer.length) {
                    this.displayedText.push(answer[i]);
                    i++;
                } else {
                    clearInterval(timer);
                }
            }, 100);
        },
        scrollToCenter() {
            const container = this.$el.querySelector(".messages");
            const chatContainer = this.$el.querySelector(".chat-container");
            console.log(container, chatContainer);
            if (container && chatContainer) {
                const containerHeight = container.scrollHeight;
                const chatHeight = chatContainer.clientHeight;

                // 计算滚动位置，让内容保持在正中间
                const scrollTop = (containerHeight - chatHeight) / 2;
                chatContainer.scrollTop = scrollTop > 0 ? scrollTop : 0;
            }
        },
    },
};
</script>

<style lang="scss">
.typewriter {
    p span[style*="font-size: 10px"] {
        /* 匹配含特定样式的 span */
        display: none !important;
    }

    p:has(> :empty:last-child) {
        /* 匹配内容为空的<p> */
        display: inline;
    }

    .hyc-common-markdown__ref-list {
        display: none !important;
    }

    blockquote {
        p {
            display: inline-block;
        }
    }

    p,
    h1,
    h2,
    h4,
    h3,
    h5,
    ul,
    ol,
    li,
    span {
        background: rgba(0, 0, 0, 0) !important;
    }

    table {
        width: 100%;
        border: 1px solid #E0E0E0 !important;
        border-collapse: collapse;
        border-spacing: 0;
        margin: 0 auto;
    }

    hr {
        border-top: 1px solid #999 !important;
        margin: 25px 0;
    }

}

.ai-chat-page {
    width: 100%;
}

.chat-container {
    // width: 100%;
    // max-width: 1200px;
    // height: 90%;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    padding: 20px;
    min-height: 90vh;
    height: calc(100vh - 40px);
    overflow-y: auto;

}

.messages {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    // justify-content: center; /* 垂直居中 */
    align-items: center;
    /* 水平居中 */
    // text-align: center; /* 文本居中 */
    width: 80%;
    margin: 0 auto;
}

.message {
    // max-width: 100%;
    padding: 10px 15px;
    border-radius: 15px;
    font-size: 14px;
    line-height: 2;
    word-wrap: break-word;
}

.message-left {
    align-self: flex-start;
    // background-color: #e5e7ed;
    color: #333;
    border-top-left-radius: 0;
    max-width: 1400px;
}

.message-right {
    align-self: flex-end;
    background-color: #37a3ff;
    color: #fff;
    border-top-right-radius: 0;
}

.thinking {
    display: flex;
    align-items: center;
    color: #666;
    font-size: 14px;
    font-style: italic;
    background-color: #e5e7ed;
    border-radius: 15px;
    border-top-left-radius: 0;
    padding-left: 20px;
    line-height: 40px;
    padding: 10px 15px;
}

.el-icon-loading {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.meun-box {
    position: fixed;
    bottom: 50%;
    left: 20px;
    padding: 3px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 2px 2px 7.7px 0px rgba(146, 159, 202, .19), 0px 0px 1px 1px rgba(255, 255, 255, .45) inset;

    .item:hover {
        background-color: #eee;
        border-radius: 10px;
    }

    span {
        padding: 7px;
        cursor: pointer;
        display: inline-block;
    }
}

.history-container {
    padding: 10px;
    width: 1200px;
    height: 90vh;

    .history-date {
        padding: 10px;
        border-radius: 10px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 14px;
        color: #666;
        background-color: #fff;
        margin-bottom: 10px;
        cursor: pointer;

        &:hover {
            box-shadow: 2px 2px 7.7px 0px rgba(146, 159, 202, .19), 0px 0px 1px 1px rgba(255, 255, 255, .45) inset;
        }
    }
}
</style>